
/**
 * Checks if an element exists based on a query selector, automatically waits for the DOM to be ready if it isn't yet
 *
 * @param {string} querySelector
 * @returns {Promise<boolean>}
 */
export async function checkIfElementExists(querySelector) {
    return new Promise((resolve) => {
        // Check if the page is already done loading
        if (document.readyState === "interactive" || document.readyState === "complete") {
            const elementExists = !! document.querySelector(querySelector);

            return resolve(elementExists);
        }

        // Page is still loading, wait for the DOMContentLoaded event
        document.addEventListener('DOMContentLoaded', () => {
            const elementExists = !! document.querySelector(querySelector);

            return resolve(elementExists);
        });
    });
}
